import { Component, Inject, Injector, OnInit } from '@angular/core';
import { DA_SERVICE_TOKEN, ITokenService } from '@delon/auth';
import { STComponentBase } from '@shared/itcore/components/st-component-base';
import { AjaxResult, AjaxResultType } from '@shared/itcore/itcore.model';
import { ItcoreSTColumn } from '@shared/itcore/services/alain.types';

@Component({
  selector: 'layout-passport',
  templateUrl: './passport.component.html',
  styleUrls: ['./passport.component.less']
})
export class LayoutPassportComponent extends STComponentBase implements OnInit {
  links = [
    {
      title: '帮助',
      href: ''
    },
    {
      title: '隐私',
      href: ''
    },
    {
      title: '条款',
      href: ''
    }
  ];

  constructor(injector: Injector, @Inject(DA_SERVICE_TOKEN) private tokenService: ITokenService) {
    super(injector);
  }
  ConfigInfo: any;
  ngOnInit(): void {
    this.tokenService.clear();

    this.http.get<AjaxResult>('api/CShop/GetManageInfo', null).subscribe((result) => {
      if (result.Type === AjaxResultType.Success) {
        this.ConfigInfo = result.Data;
      }
    });
  }

  protected GetSTColumns(): ItcoreSTColumn[] {
    return [{ required: [] }];
  }
}
